module.exports = __webpack_public_path__ + "img/epaylater-logo.42f74407.png";